module.exports = __webpack_public_path__ + "img/22.f05117fd.png";